import { FC } from 'react';
import {
  HeadSection,
  FeedSection,
  FeaturesSection,
  StartFreeSection,
  FeedSectionItemType,
  FeaturesSectionItemType,
} from '@/features/solutions';
import { CustomerFeedbackSection, LazyLottie } from '@/components';
import { useTranslation } from 'next-i18next';
import animationPreview1 from '/public/images/recruitingSolutions/animationPreview1.webp';
import animationPreview2 from '/public/images/recruitingSolutions/animationPreview2.webp';
import animationPreview3 from '/public/images/recruitingSolutions/animationPreview3.webp';
import animationPreview4 from '/public/images/recruitingSolutions/animationPreview4.webp';
import featureItemImg1 from '/public/images/recruitingSolutions/featureImg1.webp';
import featureItemImg2 from '/public/images/recruitingSolutions/featureImg2.webp';
import styles from './styles.module.scss';
import { Box } from '@mui/material';
import { ROUTES } from '@/libs/routing';

export const RecruitingSolutions: FC = () => {
  const { t } = useTranslation('recruitingSolutions');
  return (
    <>
      <HeadSection
        title={t('head.title')}
        subtitle={t('head.subtitle')}
        image={
          <Box className={styles.headImage}>
            <LazyLottie
              loop
              dataSrc="/lotties/recruitingsSolutions/animation1.json"
              previewSrc={animationPreview1}
              previewProps={{ alt: '', priority: true }}
            />
          </Box>
        }
        breadcrumbItems={[
          {
            label: t('header.nav.recruiting.title', { ns: 'common' }),
            url: ROUTES.RECRUITING_SOLUTIONS,
          },
        ]}
      />

      <FeedSection
        ns="recruitingSolutions"
        items={[
          {
            titleKey: 'feed.item1.title',
            textKey: 'feed.item1.text',
            type: FeedSectionItemType.Animation,
            animationSrc: '/lotties/recruitingsSolutions/animation2.json',
            previewSrc: animationPreview2,
          },
          {
            titleKey: 'feed.item2.title',
            textKey: 'feed.item2.text',
            type: FeedSectionItemType.Animation,
            animationSrc: '/lotties/recruitingsSolutions/animation3.json',
            previewSrc: animationPreview3,
          },
          {
            titleKey: 'feed.item3.title',
            textKey: 'feed.item3.text',
            type: FeedSectionItemType.Animation,
            animationSrc: '/lotties/recruitingsSolutions/animation4.json',
            previewSrc: animationPreview4,
          },
        ]}
      />
      <FeaturesSection
        title={t('features.title')}
        items={[
          {
            id: 'feature-1',
            title: t('features.item1.title'),
            text: t('features.item1.text'),
            type: FeaturesSectionItemType.Image,
            imageSrc: featureItemImg1,
          },
          {
            id: 'feature-2',
            title: t('features.item2.title'),
            text: t('features.item2.text'),
            type: FeaturesSectionItemType.Image,
            imageSrc: featureItemImg2,
          },
        ]}
      />
      <CustomerFeedbackSection variant="grey" />
      <StartFreeSection ns="recruitingSolutions" />
    </>
  );
};
